import * as React from "react";

const SvgWind = (props) => (
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <clipPath clipPathUnits="userSpaceOnUse" id="Wind_svg__a">
        <path d="M1235.857 386.517c-.022.001-.043.007-.065.007h-34.081a1.598 1.598 0 0 1 0-3.196h29.453a5.114 5.114 0 0 1-.388-1.949 5.144 5.144 0 1 1 10.29 0 5.145 5.145 0 0 1-5.145 5.145c-.022 0-.043-.006-.064-.007" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="Wind_svg__b">
        <path d="M1246.507 395.348c-.022 0-.043.007-.065.007h-58.577a1.598 1.598 0 1 1 0-3.195h53.95a5.104 5.104 0 0 1-.388-1.95 5.144 5.144 0 1 1 10.288 0 5.145 5.145 0 0 1-5.144 5.145c-.022 0-.042-.007-.064-.007" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="Wind_svg__c">
        <path d="M1230.776 405.431c0-.691.141-1.348.388-1.95h-18.803a1.597 1.597 0 0 1 0-3.195h23.431c.022 0 .043.005.065.007.021 0 .042-.007.064-.007a5.145 5.145 0 0 1 0 10.29 5.146 5.146 0 0 1-5.145-5.145" />
      </clipPath>
    </defs>
    <g
      style={{
        fill: "#fdb727",
        fillOpacity: 1,
      }}
    >
      <path
        style={{
          opacity: 0.996721,
          fill: "none",
          strokeWidth: 0.87871,
          strokeLinejoin: "round",
          paintOrder: "stroke fill markers",
        }}
        transform="matrix(1.33333 0 0 1.33333 639.994 -110.134)"
        d="M-479.996 82.6h71.998v71.998h-71.998z"
      />
      <g
        clipPath="url(#Wind_svg__a)"
        style={{
          fill: "#00b7f1",
          fillOpacity: 1,
        }}
        transform="matrix(1.33333 0 0 -1.33333 -1577.323 572.538)"
      >
        <g
          style={{
            fill: "#00b7f1",
            fillOpacity: 1,
          }}
        >
          <path
            d="M1235.857 386.517c-.022.001-.043.007-.065.007h-34.081a1.598 1.598 0 0 1 0-3.196h29.453a5.114 5.114 0 0 1-.388-1.949 5.144 5.144 0 1 1 10.29 0 5.145 5.145 0 0 1-5.145 5.145c-.022 0-.043-.006-.064-.007"
            style={{
              fill: "#00b7f1",
              stroke: "none",
              fillOpacity: 1,
            }}
          />
        </g>
      </g>
      <g
        clipPath="url(#Wind_svg__b)"
        style={{
          fill: "#00b7f1",
          fillOpacity: 1,
        }}
        transform="matrix(1.33333 0 0 -1.33333 -1577.323 572.538)"
      >
        <g
          style={{
            fill: "#00b7f1",
            fillOpacity: 1,
          }}
        >
          <path
            d="M1246.507 395.348c-.022 0-.043.007-.065.007h-58.577a1.598 1.598 0 1 1 0-3.195h53.95a5.104 5.104 0 0 1-.388-1.95 5.144 5.144 0 1 1 10.288 0 5.145 5.145 0 0 1-5.144 5.145c-.022 0-.042-.007-.064-.007"
            style={{
              fill: "#00b7f1",
              stroke: "none",
              fillOpacity: 1,
            }}
          />
        </g>
      </g>
      <g
        clipPath="url(#Wind_svg__c)"
        style={{
          fill: "#00b7f1",
          fillOpacity: 1,
        }}
        transform="matrix(1.33333 0 0 -1.33333 -1577.323 572.538)"
      >
        <g
          style={{
            fill: "#00b7f1",
            fillOpacity: 1,
          }}
        >
          <path
            d="M1230.776 405.431c0-.691.141-1.348.388-1.95h-18.803a1.597 1.597 0 0 1 0-3.195h23.431c.022 0 .043.005.065.007.021 0 .042-.007.064-.007a5.145 5.145 0 0 1 0 10.29 5.146 5.146 0 0 1-5.145-5.145"
            style={{
              fill: "#00b7f1",
              stroke: "none",
              fillOpacity: 1,
            }}
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgWind;
